import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import BaseModalView from "./views/base-modal-view"
import BenefitsPackageView from "./views/benefits-package-view"
import BenefitsSeriesView from "./views/benefits-series-view"
import ComposerView from "./views/composer-view"
import EventsView from "./views/events-view"
import PieceView from "./views/piece-view"
import AudioVideoView from "./views/audio-video-view"
import SelectShuttleView from "./views/select-shuttle-view"
import SelectParkingView from "./views/select-parking-view"
import ImageView from "./views/image-view"
import 'url-polyfill';


@Options({
    template: false,
    el: "body",
    ui: {
        modalTrigger: "[data-js-modal]",
    },
    regions: {
        modalRegion: '#modal-container',
    },
})
export default class ModalView extends Marionette.View<Backbone.Model>{

    region = this.getRegion("modalRegion");
    modalViews = {
        AudioVideo: AudioVideoView,
        BenefitsPackage: BenefitsPackageView,
        BenefitsSeries: BenefitsSeriesView,
        Composer: ComposerView,
        Events: EventsView,
        Piece: PieceView,
        SelectShuttle: SelectShuttleView,
        SelectParking: SelectParkingView,
        Image: ImageView,
    };

    @on("click @ui.modalTrigger")
    onModalTriggerClick(event) {
        const $target = $(event.currentTarget);
        this.handleModal($target);
    }

    deepLinkModal(id) {
        const selector = `[data-js-id=${id}]`;
        this.handleModal($(selector));
    }

    onModalClassNotFound(modalClass: string) {
        console.log(`missing modal class data attribute ${modalClass}`);
    }

    getStrippedUrl() {
        return window.location.href.split(`?modal=`)[0];
    }

    onModalContainerClose() {
        let params: any = new URLSearchParams(window.location.search);
        params.delete('modal');
        params = '?' + params.toString();
        window.history.pushState(null, '', params);
        this.region.reset();
    }

    getModalView(modalClass) {
        return this.modalViews[modalClass];
    }

    composeModal(modalData: any) {
        const View = this.getModalView(modalData.jsModal);
        const model = new Backbone.Model(modalData);
        return new View({model});
    }

    handleModal($target) {
        const data = $target.data();
        if(data){
            // to fix an issue where if the attribute was numeric, it would
            // get converted to a number instead of a string, throwing an
            // error when the template rendering code tries to call title.replace()
            if(data.jsTitle) {
                data.jsTitle = data.jsTitle.toString();
            }

            let params: any = new URLSearchParams(window.location.search);
            params.set('modal', data.jsId);
            params = '?' + params.toString();
            window.history.pushState(null, '', params);
            if (data.jsModal) {
                const modal = this.composeModal(data);
                this.displayModal(modal);
            } else {
                this.onModalClassNotFound(data.jsModal);
            }

        }
    }

    displayModal(modal) {
        const modalContainer = new BaseModalView();
        modalContainer.getRegion("container").show(modal);
        modalContainer.on("close", this.onModalContainerClose.bind(this));
        this.region.show(modalContainer);
    }
}



// WEBPACK FOOTER //
// ./@modules/modals/controller.ts